// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

import {WILDCARDBSON} from './constants'

export function checkWildcard (value) {
  if (!value) {
    return ''
  } else if (value === WILDCARDBSON) {
    return 'Global'
  }
  return value
}

export function listToText (list) {
  var outputString = ''
  if (list.length > 0) {
    outputString = outputString + list[0]
  }
  for (var i = 1; i < list.length; i++) {
    outputString = outputString + ', '
    outputString = outputString + list[i]
  }
  return outputString
}

export function getUserRoles (userRoles, roles) {
  if (userRoles && roles) {
    return roles.filter((el) => userRoles.indexOf(el.id) !== -1)
  } else {
    return []
  }
}

export function getUserRolesText (userRoles, roles) {
  var filtered = getUserRoles(userRoles, roles)
  return listToText(filtered.map((el) => el.name))
}

export function intToPermission (val) {
  if (val === 1) {
    return 'Read'
  } else if (val === 2) {
    return 'Modify'
  } else if (val === 3) {
    return 'Create'
  } else if (val === 4) {
    return 'Delete'
  } else {
    return 'Unknown: ' + val
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/@sdgsystems/vue-common/components/utils.js
// module id = 45
// module chunks = 0